import { Button, Checkbox, Classes } from '@blueprintjs/core';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { CLIENTS, LEVELS, STATES, SPECIALITIES, ERROR_TOAST_ICON, FROM_TO_DATE_TIME } from '../../../utils/Constants';
import LoadingSpinner from '../../loadingSpinner';
import { getExceptions, getTrip } from '../../services/tripApiService';
import {
	backToTopButton, checkboxMargin, exceptionsFontStyle, exceptionsHeaderContainer, exceptionsMainContainer,
	exceptionsSubContainer, flexCenter, flexRowCenter, footerButtonsContainer, justifyCenter, popoverContainerDiv
} from '../../styles';
import { AppToaster } from "../../toastComponent";
import FilterModal, { getFilters, getSpecialtyFilter } from '../modalComponents/filterModal';
import TripsDetailsComponent from '../tripDetails/tripsDetailsComponent';
import ExceptionsTable from './exceptionsTable';

const localserviceArea = JSON.parse(localStorage.getItem('serviceAreaCheckboxs'));
const localclientOptions = JSON.parse(localStorage.getItem('clientOptionsCheckboxs'));
const locallevelOptions = JSON.parse(localStorage.getItem('levelOptionsCheckboxs'));
const localspecialtyOptions = JSON.parse(localStorage.getItem('specialtyOptionsCheckboxs'));
const localFromToDateTime = JSON.parse(localStorage.getItem('fromToDateTimeValues'));

export default class ExceptionsContainer extends React.Component {

	state = {
		offsetCount: 0,
		exceptionTop: 25,
		exceptionTypes: [
			{ name: 'isRejected', label: 'Rejected', isChecked: true, id: 2 },
			{ name: 'isModified', label: 'Modified', isChecked: true, id: 1 },
			{ name: 'isSmsFailed', label: 'Failed SMS', isChecked: true, id: 3 },
			{ name: 'isUndelivered', label: 'Undelivered', isChecked: true, id: 4 },
			{ name: 'isBlocked', label: 'Blocked', isChecked: true, id: 5 },
			{ name: 'isVip', label: 'VIP', isChecked: true, id: 6 },
		],
		isLoadMoreDisabled: true,
		isLoadMoreVisible: false,
		exceptions: [],
		selectedException: null,
		selectedTrip: null,
		selectedRow: null,
		isLoading: true,
		isOpenFilter:null,
		serviceAreaCheckboxs: localserviceArea ? localserviceArea : STATES,
		clientOptionsCheckboxs: localclientOptions ? localclientOptions : CLIENTS,
		levelOptionsCheckboxs: locallevelOptions ? locallevelOptions : LEVELS,
		isLoadingDetails: false,
		specialtyOptionsCheckboxs: localspecialtyOptions ? localspecialtyOptions : SPECIALITIES,
		fromToDateTimeValues : localFromToDateTime ? localFromToDateTime : FROM_TO_DATE_TIME,
		isLoadingSpinner: false,
		isLoadingKeyEvents: false,
		sortBy: 'CreatedOnUTC',
		sortOrder: 'ASC',
		tableRef: React.createRef()
	};

	handleBackToTopClick = () => {
		this.state.tableRef.current.scrollIntoView({
			block: 'start',
			behavior: 'smooth',
		});
	}

	handleEnabledChange = async (event) => {
		const target = event.target;
		const isChecked = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		const exTypes = this.state.exceptionTypes;

		const selectedExceptionType = exTypes.filter(exceptionType => exceptionType.isChecked === true);

		if (selectedExceptionType.length === 1 && selectedExceptionType[0].name === name) {
			return;
		}

		exTypes.forEach(type => {
			if (type.name === name) {
				type.isChecked = isChecked
			}
		})

		await this.setState({
			exceptionTypes: exTypes,
		})

		this.refreshExceptions(this.state.sortBy, this.state.sortOrder);
	}

	getExceptions = async (offsetCount) => {

		const stateFilter = getFilters(this.state.serviceAreaCheckboxs);
		const clientFilter = getFilters(this.state.clientOptionsCheckboxs);
		const levelFilter = getFilters(this.state.levelOptionsCheckboxs);
		var isVip = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isVip");
		var isOversizeWC = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isOversizeWC");
		var isDialysis = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isDialysis");
		const exceptionTypeIdFilter = this.getExceptionTypeIds();

		try {
			const offset = this.state.exceptionTop * offsetCount;

			var exceptions = this.state.exceptions;
			const params = {
				top: this.state.exceptionTop, offset: offset, resolved: false, state: stateFilter,
				sortBy: this.state.sortBy, sortOrder: this.state.sortOrder, exceptionTypeId: exceptionTypeIdFilter,
				client: clientFilter, serviceLevel: levelFilter, isVip: isVip, WheelchairType: isOversizeWC,
				dialysis: isDialysis
			}

			Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);
			var newExceptions = await getExceptions(params);
			if (newExceptions.length === 0 && this.state.exceptions.length === 0) {
				AppToaster.show({ message: 'No trips found.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });

				return;
			}

			exceptions = exceptions.concat(newExceptions);

			this.setState({
				offsetCount: offsetCount,
				exceptions: exceptions,
				isLoadMoreDisabled: newExceptions.length < this.state.exceptionTop ? true : false,
			});
		}
		catch (error) {
			console.log(error);
		}
		finally {
			this.setState({
				isLoading: false,
			});
		}
	}

	setSelectedException = async (e) => {
		try {
			if (e.currentTarget !== this.state.selectedRow) {
				if (this.state.selectedRow != null) {
					const selectedRow = this.state.selectedRow;
					selectedRow.bgColor = '';

					this.setState({
						selectedRow: selectedRow,
					})
				}
				const exceptionId = e.currentTarget.getAttribute('id');

				const currentTarget = e.currentTarget;
				currentTarget.bgColor = this.props.themeName === Classes.DARK ? '#00000020' : '#cccccc';

				this.setState({
					selectedRow: currentTarget,
					isLoadingDetails: true,
					isLoadingKeyEvents: true,
				})

				const exception = this.state.exceptions.find(ex => ex.exceptionId === Number(exceptionId));
				const trip = await getTrip(exception.tripNumber);
				exception.eta = '';

				await this.setState({
					selectedTrip: trip,
					selectedException: exception,
					isLoadingDetails: false
				});
			}
		}
		catch (error) {
			console.log(error);
			let message = 'Unexpected error.';

			if (error.response?.status === 404) {
				message = 'No trip found.';
			}
			AppToaster.show({ message: message, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
		}
	}

	getExceptionTypeIds = () => {
		const selectedExceptionTypeIds = this.state.exceptionTypes.filter(exceptionType => exceptionType.isChecked);
		let isFirst = true;
		let exceptionTypeIds = '';

		selectedExceptionTypeIds.forEach(exceptionTypeId => {
			if (isFirst) {
				exceptionTypeIds += exceptionTypeId.id;
				isFirst = false;
			} else {
				exceptionTypeIds += "," + exceptionTypeId.id
			}
		});

		return exceptionTypeIds;
	}

	refreshExceptions = async (sortBy, sortOrder) => {
		await this.setState({
			isLoadMoreVisible: false,
			isLoadMoreDisabled: true,
			isLoading: true,
			offsetCount: 0,
			selectedTrip: null,
			selectedException: null,
			exceptions: [],
			sortBy: sortBy,
			sortOrder: sortOrder
		});

		this.getExceptions(this.state.offsetCount);
	}

	componentDidMount() {
		this.getExceptions(this.state.offsetCount);

		this.props.handleHeaderPathChange('Exceptions');
	}

	handleKeySpinner() {
		this.setState({ isLoadingKeyEvents: false });
	}

	handleLoadMore = async () => {
		if (this.state.exceptions.length === 0) {
			return;
		}

		var offsetCount = this.state.offsetCount + 1;

		await this.setState({
			isLoadMoreDisabled: true,
			isLoading: true,
		})

		this.getExceptions(offsetCount);
	}

	handleFilter = async () => {
		this.refreshExceptions(this.state.sortBy, this.state.sortOrder);
	}

	render() {
		var exceptionTripsCount = this.state.exceptions.length;

		return (
			<div style={exceptionsMainContainer}>
				{this.state.isLoading ? <LoadingSpinner /> : <></>}
				<div style={exceptionsSubContainer}>
					<div style={exceptionsHeaderContainer(this.props.themeName === Classes.DARK)}>
						<div style={flexCenter}>
							<span style={exceptionsFontStyle}>Exceptions: {exceptionTripsCount}</span>
							<div style={popoverContainerDiv}>
								<FilterModal fatherComponent={this} />
							</div>
						</div>
						<div>
							<div style={flexRowCenter}>
								{this.state.exceptionTypes.map(exceptionType => {
									return (
										<Checkbox
											inline key={exceptionType.name}
											name={exceptionType.name}
											checked={exceptionType.isChecked}
											label={exceptionType.label}
											onClick={this.handleEnabledChange}
											style={checkboxMargin}
										/>
									)
								})}
							</div>
						</div>
						<div style={justifyCenter}>
							<Button icon="refresh" text="Refresh" onClick={() => this.refreshExceptions(this.state.sortBy, this.state.sortOrder)} />
						</div>
					</div>

					<div className="container" ref={(ref) => this.scrollParentRef = ref}>
						<InfiniteScroll
							loadMore={this.handleLoadMore}
							hasMore={!this.state.isLoadMoreDisabled}
							threshold={100}
							useWindow={true}
							getScrollParent={() => this.scrollParentRef}
						>
							<div className="mt-5 mx-auto" ref={this.state.tableRef}>
								<ExceptionsTable
									themeName = {this.props.themeName}
									exceptions={this.state.exceptions}
									selectedTrip={this.state.selectedTrip}
									selectedException={this.state.selectedException}
									setSelectedException={this.setSelectedException}
									refreshExceptions={this.refreshExceptions}
									customFields={this.state.trips?.customFields}
									trip={this.state.trip}
								/>
							</div>
						</InfiniteScroll>
					</div>
					<footer style={footerButtonsContainer}>
						<Button style={backToTopButton} icon="arrow-up" type="button" onClick={this.handleBackToTopClick} text="Back to top" intent={'primary'} />
					</footer>
				</div>
				{
					<TripsDetailsComponent
						selectedTrip={this.state.selectedTrip}
						handleKeySpinner={this.handleKeySpinner.bind(this)}
						isLoadingKeyEvents={this.state.isLoadingKeyEvents}
						isLoadingDetails={this.state.isLoadingDetails}
					/>
				}
			</div >
		)
	}
}
